export interface Service {
  slug: string;
  title: string;
  icon: string;
  shortDesc: string;
  image: string;
  description: string;
  benefits: string[];
  process: string[];
}

export const services: Service[] = [
    {
    slug: "youtube-services",
    title: "YouTube Services",
    icon: "ri-youtube-line",
    shortDesc: "Channel management, optimization, and monetization",
    image: "https://readdy.ai/api/search-image?query=YouTube%20channel%20management%20music%20studio%20India%2C%20creator%20working%20on%20content%2C%20professional%20setup%2C%20golden%20play%20button&width=800&height=500&seq=svc015&orientation=landscape",
    description: "Complete YouTube channel management including SEO optimization, thumbnail design, monetization setup, and audience growth strategies.",
    benefits: ["Channel growth", "SEO optimization", "Monetization setup", "Analytics insights"],
    process: ["Channel audit", "SEO setup", "Content strategy", "Upload & optimize", "Growth monitoring"],
  },
  {
    slug: "music-production",
    title: "Music Production",
    icon: "ri-music-2-line",
    shortDesc: "Full-scale music production from composition to final master",
    image: "https://readdy.ai/api/search-image?query=professional%20music%20production%20studio%20India%2C%20mixing%20console%20golden%20lights%2C%20producer%20working%2C%20cinematic%20dark%20atmosphere&width=800&height=500&seq=svc001&orientation=landscape",
    description: "Our music production service covers everything from initial concept and composition to final mastering. With state-of-the-art studios and experienced producers, we bring your musical vision to life.",
    benefits: ["Professional sound quality", "Experienced producers", "Full creative support", "Industry-standard equipment"],
    process: ["Consultation & Concept", "Composition & Arrangement", "Recording Sessions", "Mixing & Mastering", "Final Delivery"],
  },
  {
    slug: "audio-recording",
    title: "Audio Recording",
    icon: "ri-mic-line",
    shortDesc: "State-of-the-art recording studios with professional engineers",
    image: "https://readdy.ai/api/search-image?query=professional%20audio%20recording%20studio%20microphone%20vocalist%20Indian%20singer%2C%20dark%20studio%20warm%20lighting%2C%20professional%20equipment&width=800&height=500&seq=svc002&orientation=landscape",
    description: "Our recording studios are equipped with top-tier microphones, preamps, and acoustic treatment to capture the perfect sound for any genre.",
    benefits: ["Acoustic excellence", "Pro equipment", "Experienced engineers", "Multiple studio rooms"],
    process: ["Pre-production planning", "Studio setup", "Recording sessions", "Playback review", "Final edit"],
  },
  {
    slug: "dubbing-voice-over",
    title: "Dubbing & Voice Over",
    icon: "ri-voiceprint-line",
    shortDesc: "Professional dubbing and voice-over services for all media",
    image: "https://readdy.ai/api/search-image?query=professional%20dubbing%20studio%20voice%20over%20recording%20booth%2C%20microphone%20headphones%2C%20dark%20professional%20atmosphere&width=800&height=500&seq=svc003&orientation=landscape",
    description: "Expert dubbing and voice-over services for films, TV, commercials, e-learning, and more. Our voice artists cover multiple regional Indian languages.",
    benefits: ["Multi-language support", "Experienced voice artists", "Quick turnaround", "Sync-perfect delivery"],
    process: ["Script review", "Voice talent selection", "Recording", "Sync & edit", "Final delivery"],
  },
  {
    slug: "mixing-mastering",
    title: "Mixing & Mastering",
    icon: "ri-equalizer-line",
    shortDesc: "Professional audio mixing and mastering for broadcast quality",
    image: "https://readdy.ai/api/search-image?query=audio%20mixing%20mastering%20studio%20professional%20engineer%20equalizer%20waveforms%2C%20dark%20cinematic%20studio%20atmosphere&width=800&height=500&seq=svc004&orientation=landscape",
    description: "Our mixing and mastering engineers ensure your music sounds great on every platform — from streaming services to broadcast TV.",
    benefits: ["Broadcast quality output", "Platform-optimized masters", "Stereo & spatial audio", "Quick revisions"],
    process: ["Track preparation", "Mixing session", "Reference checks", "Mastering", "Multi-format delivery"],
  },
  {
    slug: "video-production",
    title: "Video Production",
    icon: "ri-video-line",
    shortDesc: "Cinematic music videos and promotional content",
    image: "https://readdy.ai/api/search-image?query=Indian%20music%20video%20production%20film%20set%20camera%20crew%20cinematic%20lighting%2C%20professional%20video%20shoot&width=800&height=500&seq=svc005&orientation=landscape",
    description: "From concept to final cut, our video production team creates stunning music videos and promotional content that resonates with audiences.",
    benefits: ["Cinematic quality", "Creative direction", "Full crew & equipment", "Multiple formats"],
    process: ["Concept development", "Pre-production", "Shoot days", "Editing", "Color & VFX"],
  },
  {
    slug: "video-shooting",
    title: "Video Shooting",
    icon: "ri-camera-line",
    shortDesc: "Professional video shooting with top-tier equipment",
    image: "https://readdy.ai/api/search-image?query=professional%20video%20camera%20shooting%20Indian%20music%20artist%2C%20film%20crew%2C%20cinematic%20lighting%20setup%2C%20outdoor%20location&width=800&height=500&seq=svc006&orientation=landscape",
    description: "Our video shooting service covers studio shoots, outdoor locations, live events, and performances with professional cinema-grade cameras.",
    benefits: ["Cinema-grade cameras", "Professional lighting", "Experienced DOP", "Location flexibility"],
    process: ["Location scouting", "Equipment setup", "Shoot execution", "Review & selects", "Delivery"],
  },
  {
    slug: "video-editing",
    title: "Video Editing",
    icon: "ri-scissors-cut-line",
    shortDesc: "Creative video editing with stunning visual effects",
    image: "https://readdy.ai/api/search-image?query=professional%20video%20editing%20workstation%20multiple%20screens%20timeline%2C%20dark%20editing%20suite%2C%20creative%20post%20production&width=800&height=500&seq=svc007&orientation=landscape",
    description: "Professional video editing that transforms raw footage into compelling stories. We handle cuts, transitions, motion graphics, and full post-production.",
    benefits: ["Creative storytelling", "Motion graphics", "Quick turnaround", "Unlimited revisions"],
    process: ["Footage review", "Assembly cut", "Fine cut", "Graphics & effects", "Final export"],
  },
  {
    slug: "post-production",
    title: "Post Production",
    icon: "ri-film-line",
    shortDesc: "Complete post-production including color grading and VFX",
    image: "https://readdy.ai/api/search-image?query=post%20production%20studio%20color%20grading%20suite%20professional%20workstation%2C%20cinematic%20dark%20atmosphere%2C%20film%20editing&width=800&height=500&seq=svc008&orientation=landscape",
    description: "End-to-end post-production services including color grading, VFX, sound design, and final delivery in all required formats.",
    benefits: ["Professional color grade", "VFX capabilities", "Sound design", "All format delivery"],
    process: ["Offline edit", "Color grading", "VFX & compositing", "Sound mix", "Final delivery"],
  },
  {
    slug: "artist-management",
    title: "Artist Management",
    icon: "ri-user-star-line",
    shortDesc: "End-to-end career management for emerging and established artists",
    image: "https://readdy.ai/api/search-image?query=Indian%20music%20artist%20manager%20meeting%2C%20professional%20business%20discussion%2C%20modern%20office%2C%20music%20industry&width=800&height=500&seq=svc009&orientation=landscape",
    description: "Comprehensive artist management covering career development, bookings, contracts, brand deals, and public relations for Indian music artists.",
    benefits: ["Career strategy", "Brand partnerships", "Event bookings", "PR management"],
    process: ["Artist evaluation", "Strategy planning", "Brand building", "Booking management", "Growth tracking"],
  },
  {
    slug: "casting-auditions",
    title: "Casting & Auditions",
    icon: "ri-star-line",
    shortDesc: "Professional casting services for music videos and productions",
    image: "https://readdy.ai/api/search-image?query=Indian%20music%20audition%20casting%20session%2C%20performers%20waiting%2C%20professional%20audition%20room%2C%20talent%20selection&width=800&height=500&seq=svc010&orientation=landscape",
    description: "Professional casting and audition management for music videos, TV shows, films, and live performances across India.",
    benefits: ["Large talent pool", "Regional expertise", "Fast turnaround", "Nationwide reach"],
    process: ["Brief analysis", "Talent search", "Audition rounds", "Selection", "Onboarding"],
  },
  {
    slug: "digital-promotion",
    title: "Digital Promotion",
    icon: "ri-global-line",
    shortDesc: "Strategic digital marketing across all major platforms",
    image: "https://readdy.ai/api/search-image?query=digital%20marketing%20music%20promotion%20social%20media%20analytics%20dashboard%2C%20modern%20office%2C%20data%20visualization&width=800&height=500&seq=svc011&orientation=landscape",
    description: "Data-driven digital promotion strategies that get your music heard by millions across YouTube, Spotify, Apple Music, and social media platforms.",
    benefits: ["Multi-platform reach", "Data analytics", "Targeted campaigns", "ROI focused"],
    process: ["Audience analysis", "Campaign planning", "Content creation", "Launch & promote", "Analytics review"],
  },
  {
    slug: "social-media-marketing",
    title: "Social Media Marketing",
    icon: "ri-share-line",
    shortDesc: "Build and grow your social media presence",
    image: "https://readdy.ai/api/search-image?query=social%20media%20marketing%20team%20working%20on%20music%20promotion%2C%20smartphones%20tablets%2C%20modern%20creative%20office&width=800&height=500&seq=svc012&orientation=landscape",
    description: "Full social media management and marketing across Instagram, Facebook, YouTube, and more. We build engaged communities around your brand.",
    benefits: ["Platform expertise", "Content calendar", "Community management", "Paid campaigns"],
    process: ["Profile audit", "Strategy planning", "Content creation", "Posting & engagement", "Monthly reports"],
  },
  {
    slug: "music-distribution",
    title: "Music Distribution",
    icon: "ri-send-plane-line",
    shortDesc: "Global music distribution across 150+ streaming platforms",
    image: "https://readdy.ai/api/search-image?query=music%20streaming%20distribution%20platforms%20digital%20music%20release%2C%20modern%20technology%2C%20global%20reach%20visualization&width=800&height=500&seq=svc013&orientation=landscape",
    description: "Get your music on every major streaming platform worldwide — Spotify, Apple Music, Amazon Music, JioSaavn, Gaana, and 150+ more.",
    benefits: ["150+ platforms", "Fast release", "Royalty collection", "Analytics dashboard"],
    process: ["Music upload", "Metadata setup", "Platform submission", "Release scheduling", "Royalty tracking"],
  },
  {
    slug: "content-creation",
    title: "Content Creation",
    icon: "ri-edit-line",
    shortDesc: "Creative content for all digital platforms",
    image: "https://readdy.ai/api/search-image?query=content%20creation%20studio%20Indian%20music%20digital%20media%2C%20creative%20team%20filming%2C%20modern%20production%20setup&width=800&height=500&seq=svc014&orientation=landscape",
    description: "End-to-end content creation including short videos, reels, thumbnails, graphics, and written content for all your digital platforms.",
    benefits: ["Platform-optimized", "Brand consistent", "High engagement", "Fast delivery"],
    process: ["Brief & planning", "Content creation", "Review & approval", "Scheduling", "Performance tracking"],
  },

];
